import client from '../client';
import { uploadImg, uploadFile} from '../../utils'

export default {
  agreeToNotice: data => {
    return client.post('seller/agree-to-notice', data).then(res => res.data);
  },
  getSellerBrands: data => {
    return client.get('seller/brands/all', data).then(res => res.data);
  },
  activateBrands: data => {
    return client.post('seller/brands/activate', data).then(res => res.data);
  },
  uploadImg: async data => uploadImg(data),
  uploadFile: async data => {
    return client.post('common/upload', data).then(res => res.data);
  },
  getCommissionConfig:data=>{//获取平台佣金配置比例
    return client.get('commission/config', data).then(res => res.data);
  },
  switchCountry:data=>{
    return client.post('seller/switch-country', data).then(res => res.data);
  },
  reauthorize:data=>{
    return client.post('seller/reauthorize', data).then(res => res.data);
  },
  // Seller 完成associate弹窗
  associateCompleted: data => {
    return client.post('seller/associateCompleted', data).then(res => {
      if (!res || !res.data) {
        throw new Error('Invalid response');
      }
      return res.data;
    });
  },
  associatePublisherCompleted: data => {
    return client.post('seller/associatePublisherCompleted', data).then(res => {
      if (!res || !res.data) {
        throw new Error('Invalid response');
      }
      return res.data;
    });
  },
  associatePublisherDetailCompleted: data => {
    return client.post('seller/associatePublisherDetailCompleted', data).then(res => {
      if (!res || !res.data) {
        throw new Error('Invalid response');
      }
      return res.data;
    });
  },
  attributionAssociateSplitCompleted: data => {
    return client.post('seller/attributionAssociateSplitCompleted', data).then(res => {
      if (!res || !res.data) {
        throw new Error('Invalid response');
      }
      return res.data;
    });
  },
  getPopActive: data => {
    return client.get('seller/popups/active', {params:data}).then(res => res.data);
  },
  dismissPopActive: data => {
    return client.post('seller/popups/dismiss', data).then(res => res.data);
  },
}